export default "__VITE_PUBLIC_ASSET__6613041a__"